var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05469 8.25C1.11719 8.25 0.609375 7.11719 1.3125 6.41406L6.46875 1.10156C6.66406 0.867188 6.97656 0.75 7.25 0.75C7.52344 0.75 7.79688 0.867188 7.99219 1.10156L13.1484 6.41406C13.8516 7.11719 13.3438 8.25 12.4062 8.25H2.05469ZM12.4062 10.75C13.3438 10.75 13.8516 11.9219 13.1484 12.625L7.99219 17.9375C7.79688 18.1719 7.52344 18.25 7.25 18.25C6.9375 18.25 6.66406 18.1719 6.46875 17.9375L1.3125 12.625C0.609375 11.9219 1.11719 10.75 2.05469 10.75H12.4062Z",
    fill: "#476930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.3f75da3100e45197cd7744045ec6562a.svg";
export { ForwardRef as ReactComponent };